import photos from './photos'
import videos from './videos'

export default {
  modules: {
    photos,
    videos
  }
}
